import React from "react";
import { Provider, useSelector } from "react-redux";
import { BrowserRouter, useLocation } from "react-router-dom";
import { ThemeSwitcherProvider } from "react-css-theme-switcher";
import store from "./store";
import Layouts from "./layouts";
import Routes from "./routes";
import { THEME_CONFIG } from "./configs/AppConfig";
import "./lang";

const themes = {
  dark: `${process.env.PUBLIC_URL}/css/dark-theme.css`,
  light: `${process.env.PUBLIC_URL}/css/light-theme.css`,
};

const AppContent = () => {
  const location = useLocation();
  localStorage.setItem(
    "token",
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjY5MzgyY2RhYTM4ODhmMWQ2M2E1MzYxZCIsInJvbGUiOnsiX2lkIjoiNjg3MDY0M2Q2M2EzMzRhNzUwMjViODEzIiwibmFtZSI6InVzZXIiLCJwZXJtaXNzaW9ucyI6W119LCJzZXNzaW9uSWQiOiI2OTM4MmNlNmEzODg4ZjFkNjNhNTM2MmMiLCJpYXQiOjE3NjUyODkxOTAsImV4cCI6MTc3Mzg0Mjc5MH0.BLoPoOdeWx7lfsdtyw2aCtSvgCJbYRZCxETp6xD_ecs"
  );

  // Hide main layout for preview routes
  const isPreview = location.pathname.startsWith("/preview/flow");

  return isPreview ? (
    <Routes /> // render routes directly (standalone)
  ) : (
    <Layouts>
      <Routes /> // render routes with full layout
    </Layouts>
  );
};

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <ThemeSwitcherProvider
          themeMap={themes}
          defaultTheme={THEME_CONFIG.currentTheme}
          insertionPoint="styles-insertion-point"
        >
          <AppContent />
        </ThemeSwitcherProvider>
      </BrowserRouter>
    </Provider>
  );
}

export default App;
